import React from 'react';
import {InputText} from 'primereact/inputtext';
import _ from 'lodash';
import {FormControlComponentDefaultProps} from 'components/FormControl';
import {FormPageFieldComponentDefaultProps} from 'types/formPage';
import cls from './display.module.scss';
import {InputTextarea} from "primereact/inputtextarea";
import {Checkbox} from '../AirtableFields/Checkbox';
import {
    colorOption,
    convertColor,
    extract,
    fieldDefaultConfig, FieldTypes, findCollab, formatCustomValue,
    formatValue, formatValueWithCustom, getRFDOptions, openUrl, renderCollabOpt,
    renderRecord,
    renderValue, toBool,
    toDivider, wrapArray
} from "../utils";
import {Card} from "primereact/card";
import {IframeEditorMemo} from "../AirtableFields/BaseFields/BaseEditor";
import {Navigator} from "./Navigator";
import {VirtualScroller} from "primereact/virtualscroller";
import {Tag} from 'primereact/tag';
import {Badge} from 'primereact/badge';
import {DataView} from "primereact/dataview";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {BaseSelect} from "../SelectOptions/BaseSelect";
import {Button} from "primereact/button";
import AttachmentViewer from "../AirtableFields/Attachments/AttachmentViewer";
import {Gallery} from "./Gallery";
import {Carousel} from './Carousel';
import {Paginator} from './Paginator';
import Formula from "../CustomFormFields/Formula";
import {useFormikContext} from "formik";
import Table from "../Table";
import {Galleria} from "primereact/galleria";
import {LinkedFieldDisplayRender} from "../CustomFormFields/LinkedFieldDisplayRender";
import {Attachments} from "../AirtableFields/Attachments";
import GoogleFieldComp from "../CustomFormFields/GoogleField";
import Embed from "../CustomFormFields/Embed";
import {useStore} from "../../@redux";


export type DisplayRenderingProps = FormControlComponentDefaultProps &
    FormPageFieldComponentDefaultProps & { env?: string, recordData?: any };

export const DisplayRendering = ({  value, env = 'form', recordData, name, ...rest }: DisplayRenderingProps) => {
    const {details, extraConfig} = rest
    const {title, divider, inline=false, type, as_array = false, array_sep, options: fieldOptions} = extraConfig;
    const defs = fieldDefaultConfig(env, type, fieldOptions, extraConfig)
    const {
        values: formValues,

    } = useFormikContext();
    const { render_as,  display_as, always_display, format_as } = getRFDOptions(defs, extraConfig);
    console.log("Display Rendering Start", {fieldName: details?.field?.name, title, value, fieldOptions, extraConfig, defs, render_as, display_as, always_display, format_as} )
    if([FieldTypes.FT_LOOKUP].includes(details?.field?.type) && fieldOptions?.recordLinkFieldId && fieldOptions?.lookupFieldName && _.has(formValues,fieldOptions?.recordLinkFieldId)){
        const {recordLinkFieldId, lookupFieldName, lookupFieldId} = fieldOptions
        console.log('DisplayRendering Link Field Before', details?.field?.name, {recordLinkFieldId, lookupFieldName, lookupFieldId, formValues, value, fieldOptions, defs, render_as, display_as, always_display})
        value = (formValues[recordLinkFieldId] || []).map( rec => rec[lookupFieldId] ?? rec[lookupFieldName] )
        console.log('DisplayRendering Link Field After', details?.field?.name, formValues, value, fieldOptions, defs, render_as, display_as, always_display)
    }

    if(details?.field?.type === FieldTypes.FT_ROLLUP)console.log("ROLLUP VALUE BEFORE", value)
    if(as_array && _.isString(value))value = value.split(array_sep || ",")
    if(!_.isArray(value) || render_as === 'json')value = wrapArray( value )
    if(details?.field?.type === FieldTypes.FT_ROLLUP)console.log("ROLLUP VALUE AFTER", value)
    const render = (oriValue, settings:any = {}) => {
        const renderOptions = {...defs, ...extraConfig, ...settings}

        let element = ['formula'].includes(render_as) ? oriValue : formatValueWithCustom( env, oriValue, renderOptions, details, recordData )
        if(fieldOptions?.recordLinkFieldId){
            console.log('DisplayRendering Render', env, render_as, display_as, format_as, element, oriValue, renderOptions, defs, extraConfig, settings)
        }
        if (render_as === 'input') {
            return <InputText value={element} disabled/>
        } else if (render_as === 'textarea') {
            return <InputTextarea value={element} disabled
                                  {...extract({rows: 10}, renderOptions)}/>
        } else if (render_as === 'texteditor') {
            return <IframeEditorMemo editorMode={'text'} value={element} id={name}
                                     extraConfig={{display_status: 'disable'}}/>
        } else if (render_as === 'json') {
            return <IframeEditorMemo editorMode={'json'} value={element} id={name}
                                     extraConfig={{display_status: 'disable'}}/>
        } else if (['frame','iframe'].includes(render_as)) {
            return <iframe src={element} {...extract({
                width: '100%',
                height: '500px',
                style: undefined
            }, renderOptions)}/>
        } else if (render_as === 'image') {
            return <img src={element} {...extract({
                width: undefined,
                height: undefined,
                style: undefined
            }, renderOptions)}/>
        } else if (render_as === 'attachment') {
            console.log('Display Render Attachment', element, renderOptions, env)
            return <AttachmentViewer env={env} attachment={element} {...extract( {fullscreen: undefined, thumbnail: undefined}, renderOptions)} extraConfig={extraConfig}/>
        }else if(render_as === 'collaborator'){
            const all = _.get(details, 'collabs', [])
            const item = findCollab(all, element)
            const collab = item ? renderCollabOpt(item, renderOptions) : ''
            console.log('COLLAB DISPLAY', oriValue, item, all)
            return <>{collab}</>
        }else if(['tag','pill','badge'].includes(render_as)){
            const {colors: useColors = true, severity = '', size = ''} = renderOptions
            const choices = _.get(renderOptions, 'options.choices')
            const choice = (choices || []).find(c => c.name === element)
            const colors = severity ? null : (_.isArray(useColors) ? useColors : (useColors ? (choice ? convertColor(choice?.color) : colorOption(settings.index >= 0 ? settings.index : false)) : null))
            return (render_as === 'badge' || size) ?
                <Badge value={element}  size={size}  {...extract({style: colors ? {background:colors[0], color: colors[1]} : undefined, severity: severity || undefined, icon: undefined}, renderOptions)}/>
                : <Tag value={element}  {...extract({style: colors ? {background:colors[0], color: colors[1]} : undefined, severity: severity || undefined, rounded: render_as === 'pill'}, renderOptions)}/>
        }else if( render_as === 'boolean'){
            const {onLabel = 'YES', offLabel = 'NO', default:defaultBool = false} = renderOptions
            if(element === true || element === false)return element
            if(!element)return defaultBool
            if(`${element}`.toLowerCase() === `${onLabel}`.toLowerCase())return true
            if(`${element}`.toLowerCase() === `${offLabel}`.toLowerCase())return false
            if(['1','on','yes','true'].includes(`${element}`.toLowerCase()))return true
            if(['0','off','no','false'].includes(`${element}`.toLowerCase()))return false
            return defaultBool
        } else if (render_as === 'record') {
            const {state = {}} = renderOptions
            console.log('Render Display Record', element, state, renderOptions)
            return renderRecord( env, element, renderOptions, {...state, details} )
        }else if(render_as === 'button'){
            const location = _.get(renderOptions,'location')
            const {url,label:btnLabel = null} = _.isString(element) ? {url:element} : (element || {} )
            const useUrl = url || _.get(renderOptions,'url')
            const btnOptions = extract( {classes: undefined, label: btnLabel || 'Open', severity: undefined, outlined:undefined,raised:undefined,rounded:undefined,link:undefined,tooltip:undefined, size:undefined,btnIcon: undefined,btnIconPos: undefined,badge: undefined,badgeClassName: undefined,
                style: undefined}, renderOptions, {}, false, {classes: 'className', btnIcon: 'icon', btnIconPos: 'iconPos'})
            console.log('Rendering Display Button', renderOptions, element, btnOptions)
            return <Button {...btnOptions} onClick={openUrl(useUrl,location,true)} />
        }
        return renderValue(element, renderOptions)

    }
    const display = ( ) => {
        console.log('Display Render', details?.field?.name, details, env, display_as, render_as, format_as, value, always_display)
        const items = []
        if (value.length || always_display) {
            const {showEmpty = false} = extraConfig
            value = _.flattenDeep(value).filter(el => showEmpty || !!el)
            if (display_as === 'gallery') {
                console.log("Displaying as Gallery", env, value, extraConfig)
                items.push(<Gallery env={env} value={value} render={item => render(item)}
                                    thumbnail={item => render(item, {thumbnail: true})}
                                    extraConfig={extraConfig}/>)
            } else if (display_as === 'attachment'){
                items.push(<Attachments name={name} value={value} view_only={true} extraConfig={extraConfig}/> )
            }else if (['navigate', 'navigator'].includes(display_as)) {

                items.push(<Navigator value={value} render={render}
                                      extraConfig={extraConfig}/>)

            }  else if (display_as === 'table') {
                extraConfig.column_header = false
                return (
                    <Table env={env} name={name} form_id={null} display_as={'table'} mode={'table'} value={value}
                           getRecord={null} createForm={null} details={details} extraConfig={extraConfig}
                           recordSearch={null} onSaveEdit={null}/>
                )


            } else if (['list', 'grid'].includes(display_as)) {
                const itemTemplate = (item, mode) => {
                    const index = value.indexOf(item)
                    const settings = {index, count: value.length}
                    return mode === 'list' ? <div key={`${name}_${index}`}
                                                  className={`col-12 ${name}_${index}`}>{render(item, settings)}</div> :
                        <div key={`${name}_${index}`} className={`col-${12/Number(`${_.get(extraConfig, 'grid_columns', 4)}`)}`}>{render(item, settings)}</div>;
                }
                const params = extract({
                    paginator: undefined,
                    alwaysShowPaginator: undefined,
                    paginatorTemplate: undefined,
                    pageLinkSize: undefined,
                    currentPageReportTemplate: undefined,
                    emptyMessage: undefined,
                    gutter: undefined,
                    sortField: undefined,
                    sortOrder: undefined,
                    paginatorPosition: undefined,
                    rows: 10
                }, extraConfig)
                items.push(<DataView key={`${name}_list}`} value={value} layout={display_as}
                                     itemTemplate={itemTemplate} {...params}/>)
            } else if (display_as === 'scroller') {
                const params = extract({}, extraConfig)
                const itemTemplate = (item, options) => {
                    // item: Current item.
                    // options.index: Index of the item.
                    // options.count: Total numbers of items.
                    // options.first: Whether this is the first item.
                    // options.last: Whether this is the last item.
                    // options.even: Whether the index is even.
                    // options.odd: Whether the index is odd.
                    // options.props: Props of component.

                    return <div style={{height: '50px'}}>{render(item, options)}</div>;
                }
                console.log('Scroller', value, params)
                items.push(<VirtualScroller style={{height: '100px'}} items={value} itemSize={50}
                                            itemTemplate={itemTemplate} {...params}/>)
            } else if (['card', 'block'].includes(display_as)) {
                for (let i = 0; i < value.length; i++) {
                    items.push(<Card>{render(value[i], {index: i, count: value.length})}</Card>)
                    if (i < value.length - 1) items.push(toDivider(divider))
                }

            } else if (display_as === 'carousel') {
                console.log("Display Render Carousel", env, value, extraConfig)
                items.push(<Carousel env={env} value={value} render={item => render(item)}
                                     extraConfig={extraConfig}/>)
            } else if (['paginator', 'paginate'].includes(display_as)) {
                items.push(<Paginator env={env} value={value} render={item => render(item)}
                                      extraConfig={extraConfig}/>)
            } else if (display_as === 'line') {
                for (let i = 0; i < value.length; i++) {
                    items.push(render(value[i], {index: i, count: value.length}))
                    if (i < value.length - 1) items.push(toDivider(divider, ' '))
                }
            } else if (['buttons_select', 'checkbox_select', 'radio_select', 'autocomplete', 'multiselect', 'dropdown', 'listbox'].includes(display_as)) {
                const [selMode] = display_as.split('_')
                const choices = value.map(v => ({name: v}))
                console.log('base select', selMode, display_as, choices)
                const multiple = rest['multiple'] === undefined ? !['radio', 'dropdown'].includes(selMode) : rest['multiple']
                items.push(<BaseSelect name={name} value={multiple ? value : value[0]} disabled={true}
                                       multiple={multiple} extraConfig={{
                    options: {choices}, ...extraConfig,
                    display_as: selMode,
                    allow_create: false
                }}/>)
            } else if (['checkbox', 'select_switch', 'switch', 'button_toggle'].includes(display_as)) {
                const [cbMode] = display_as.split('_')
                for (let i = 0; i < value.length; i++) {
                    items.push(<Checkbox name={name}
                                         value={render(value[i], {index: i, count: value.length, as_bool: true})}
                                         disabled={true}
                                         extraConfig={{...extraConfig, display_as: cbMode}}/>)
                }
            } else if (['formula'].includes(display_as)) {
                console.log('Display Rendering Formula', display_as, name, extraConfig, rest)
               //items.push(<Formula name={name} extraConfig={extraConfig} recordData={recordData} {...rest}/> )
                items.push( formatCustomValue(env, details, FieldTypes.CUSTOM_FORMULA, extraConfig, recordData, true ) )
            } else if (['content'].includes(display_as)) {
                console.log('Display Rendering Content', display_as, name, extraConfig, rest)
                //items.push(<Formula name={name} extraConfig={extraConfig} recordData={recordData} {...rest}/> )
                items.push( formatCustomValue(env, details, FieldTypes.CUSTOM_TEXT, extraConfig, recordData, true ) )
            } else if (['linked_field_display'].includes(display_as)) {
                items.push(<LinkedFieldDisplayRender value={value} name={name} env={env} details={details} extraConfig={extraConfig}/>);

            }else if(['google'].includes(display_as)){
                items.push(<GoogleFieldComp value={value} name={name} env={env} details={details} extraConfig={extraConfig}/>)
            }else if(['embed'].includes(display_as)){
                items.push(<Embed value={value} name={name} env={env} details={details} extraConfig={extraConfig}/>)
            }else {
                //plain text
                console.log('Rendering Plain Value', value)
                for (let i = 0; i < value.length; i++) {
                    const rendVal = render(value[i], {index: i, count: value.length})
                    if(inline)items.push(rendVal)
                    else items.push(<div key={`${name}_${i}`}>{rendVal}</div>)
                    if (i < value.length - 1) items.push(toDivider(divider))
                }


            }
        } else {
            const {emptyMessage} = extract({emptyMessage: ''}, extraConfig) as any
            items.push(renderValue(emptyMessage))
        }
        return <>{items}</>
    }

    return (
        <div className={cls.wrapper}>
            {display()}
        </div>
    );
};

export default DisplayRendering;
